"use strict";Object.defineProperty(exports, "__esModule", {value: true});












var _chunkJALX2CO3js = require('./chunk-JALX2CO3.js');













exports.BodyPrimary = _chunkJALX2CO3js.BodyPrimary; exports.BodySecondary = _chunkJALX2CO3js.BodySecondary; exports.Caption = _chunkJALX2CO3js.Caption; exports.H1 = _chunkJALX2CO3js.H1; exports.H2 = _chunkJALX2CO3js.H2; exports.H3 = _chunkJALX2CO3js.H3; exports.H4 = _chunkJALX2CO3js.H4; exports.H5 = _chunkJALX2CO3js.H5; exports.H6 = _chunkJALX2CO3js.H6; exports.LabelMini = _chunkJALX2CO3js.LabelMini; exports.LabelMiniStrong = _chunkJALX2CO3js.LabelMiniStrong; exports.LabelStrong = _chunkJALX2CO3js.LabelStrong;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiJ9